export const CURATED_TIMEZONES: ReadonlyArray<{ readonly name: string; readonly iana: string }> = [
  // Pinned top entries
  { name: 'Pacific Time - US & Canada', iana: 'America/Los_Angeles' },
  { name: 'Eastern Time - US & Canada', iana: 'America/New_York' },
  { name: 'Central European Time', iana: 'Europe/Berlin' },
  { name: 'UTC Time', iana: 'Etc/UTC' },
  // Remaining — sorted alphabetically by display name
  { name: 'Adelaide Time', iana: 'Australia/Adelaide' },
  { name: 'Africa/Cairo', iana: 'Africa/Cairo' },
  { name: 'Africa/Windhoek', iana: 'Africa/Windhoek' },
  { name: 'Alaska Time', iana: 'America/Anchorage' },
  { name: 'America/Adak', iana: 'America/Adak' },
  { name: 'America/Campo Grande', iana: 'America/Campo_Grande' },
  { name: 'America/Godthab', iana: 'America/Nuuk' },
  { name: 'America/Havana', iana: 'America/Havana' },
  { name: 'America/Mazatlan', iana: 'America/Mazatlan' },
  { name: 'America/Miquelon', iana: 'America/Miquelon' },
  { name: 'America/Noronha', iana: 'America/Noronha' },
  { name: 'America/Santa Isabel', iana: 'America/Tijuana' },
  { name: 'Arizona, Yukon Time', iana: 'America/Phoenix' },
  { name: 'Asia/Baku', iana: 'Asia/Baku' },
  { name: 'Asia/Dhaka', iana: 'Asia/Dhaka' },
  { name: 'Asia/Gaza', iana: 'Asia/Gaza' },
  { name: 'Asia/Irkutsk', iana: 'Asia/Irkutsk' },
  { name: 'Asia/Omsk', iana: 'Asia/Omsk' },
  { name: 'Asia/Rangoon', iana: 'Asia/Yangon' },
  { name: 'Asia/Vladivostok', iana: 'Asia/Vladivostok' },
  { name: 'Asia/Yakutsk', iana: 'Asia/Yakutsk' },
  { name: 'Asia/Yerevan', iana: 'Asia/Yerevan' },
  { name: 'Asuncion Time', iana: 'America/Asuncion' },
  { name: 'Atlantic Standard Time', iana: 'America/Puerto_Rico' },
  { name: 'Atlantic Time', iana: 'America/Halifax' },
  { name: 'Auckland Time', iana: 'Pacific/Auckland' },
  { name: 'Australia/Darwin', iana: 'Australia/Darwin' },
  { name: 'Australia/Eucla', iana: 'Australia/Eucla' },
  { name: 'Australia/Lord Howe', iana: 'Australia/Lord_Howe' },
  { name: 'Australia/Perth', iana: 'Australia/Perth' },
  { name: 'Azores Time', iana: 'Atlantic/Azores' },
  { name: 'Baghdad, East Africa Time', iana: 'Asia/Baghdad' },
  { name: 'Bogota, Jamaica, Lima Time', iana: 'America/Bogota' },
  { name: 'Brasilia Time', iana: 'America/Sao_Paulo' },
  { name: 'Brisbane Time', iana: 'Australia/Brisbane' },
  { name: 'Buenos Aires Time', iana: 'America/Argentina/Buenos_Aires' },
  { name: 'Cape Verde Time', iana: 'Atlantic/Cape_Verde' },
  { name: 'Caracas Time', iana: 'America/Caracas' },
  { name: 'Central Africa Time', iana: 'Africa/Johannesburg' },
  { name: 'Central Time - US & Canada', iana: 'America/Chicago' },
  { name: 'China, Singapore, Perth', iana: 'Asia/Shanghai' },
  { name: 'Dubai Time', iana: 'Asia/Dubai' },
  { name: 'Eastern European Time', iana: 'Europe/Helsinki' },
  { name: 'Hawaii Time', iana: 'Pacific/Honolulu' },
  { name: 'India, Sri Lanka Time', iana: 'Asia/Kolkata' },
  { name: 'Indochina Time', iana: 'Asia/Bangkok' },
  { name: 'Israel Time', iana: 'Asia/Jerusalem' },
  { name: 'Japan, Korea Time', iana: 'Asia/Tokyo' },
  { name: 'Jordan Time', iana: 'Asia/Amman' },
  { name: 'Kabul Time', iana: 'Asia/Kabul' },
  { name: 'Kathmandu Time', iana: 'Asia/Kathmandu' },
  { name: 'Krasnoyarsk Time', iana: 'Asia/Krasnoyarsk' },
  { name: 'Lebanon Time', iana: 'Asia/Beirut' },
  { name: 'Mexico City Time', iana: 'America/Mexico_City' },
  { name: 'Minsk Time', iana: 'Europe/Minsk' },
  { name: 'Montevideo Time', iana: 'America/Montevideo' },
  { name: 'Moscow Time', iana: 'Europe/Moscow' },
  { name: 'Mountain Time - US & Canada', iana: 'America/Denver' },
  { name: 'Newfoundland Time', iana: 'America/St_Johns' },
  { name: 'Pacific/Apia', iana: 'Pacific/Apia' },
  { name: 'Pacific/Chatham', iana: 'Pacific/Chatham' },
  { name: 'Pacific/Easter', iana: 'Pacific/Easter' },
  { name: 'Pacific/Fiji', iana: 'Pacific/Fiji' },
  { name: 'Pacific/Gambier', iana: 'Pacific/Gambier' },
  { name: 'Pacific/Kiritimati', iana: 'Pacific/Kiritimati' },
  { name: 'Pacific/Majuro', iana: 'Pacific/Kwajalein' },
  { name: 'Pacific/Marquesas', iana: 'Pacific/Marquesas' },
  { name: 'Pacific/Norfolk', iana: 'Pacific/Norfolk' },
  { name: 'Pacific/Noumea', iana: 'Pacific/Noumea' },
  { name: 'Pacific/Pago Pago', iana: 'Pacific/Pago_Pago' },
  { name: 'Pacific/Pitcairn', iana: 'Pacific/Pitcairn' },
  { name: 'Pacific/Tarawa', iana: 'Pacific/Tarawa' },
  { name: 'Pacific/Tongatapu', iana: 'Pacific/Tongatapu' },
  { name: 'Pakistan, Maldives Time', iana: 'Asia/Karachi' },
  { name: 'Santiago Time', iana: 'America/Santiago' },
  { name: 'Saskatchewan, Guatemala, Costa Rica Time', iana: 'America/Regina' },
  { name: 'Sydney, Melbourne Time', iana: 'Australia/Sydney' },
  { name: 'Syria Time', iana: 'Asia/Damascus' },
  { name: 'Tehran Time', iana: 'Asia/Tehran' },
  { name: 'Turkey Time', iana: 'Europe/Istanbul' },
  { name: 'UK, Ireland, Lisbon Time', iana: 'Europe/London' },
  { name: 'West Africa Time', iana: 'Africa/Lagos' },
  { name: 'Yekaterinburg Time', iana: 'Asia/Yekaterinburg' },
];

/**
 * Returns the curated display name for a stored IANA timezone identifier.
 * Falls back to the raw IANA string when no curated entry matches.
 * E.g. 'America/St_Johns' → 'Newfoundland Time', 'Etc/UTC' → 'UTC Time'
 */
export const getTimezoneDisplayName = (iana: string): string =>
  CURATED_TIMEZONES.find((item) => item.iana === iana)?.name ?? iana;

/**
 * Formats the current UTC offset for an IANA timezone as a string like 'UTC-5' or 'UTC+5:30'.
 * Uses the current wall-clock time so DST is correctly reflected.
 */
const getUtcOffsetString = (iana: string): string => {
  const gmtOffset = new Date()
    .toLocaleString('en-US', { timeZone: iana, timeZoneName: 'shortOffset' })
    .match(/GMT([+-]\d+(?::\d+)?)/)?.[1] ?? '0';

  const parts = gmtOffset.split(':');
  const offsetMinutes = parts.reduce((acc, part, idx) => acc + (idx === 0 ? Number(part) * 60 : Number(part)), 0);

  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;
  return minutes === 0 ? `UTC${sign}${hours}` : `UTC${sign}${hours}:${String(minutes).padStart(2, '0')}`;
};

/**
 * Returns the full timezone label including the current UTC offset.
 * E.g. 'America/New_York' → 'Eastern Time - US & Canada (UTC-5)'
 *      'Asia/Kolkata'      → 'India, Sri Lanka Time (UTC+5:30)'
 */
export const getTimezoneLabel = (iana: string): string =>
  `${getTimezoneDisplayName(iana)} (${getUtcOffsetString(iana)})`;
